import { CornerRightDownIcon, LineIcon, Plus1Icon, ButtonIcon, Tooltip } from 'canoe';
import React from 'react';

import { useNodesData, useSelection } from 'craft/hooks';
import { useColumnOperations } from 'craft/hooks/useColumnOperations';

export const ColumnButtons = () => {
  const { selection } = useSelection();
  const id = selection.last;

  const [nodeData] = useNodesData([id]);
  const [parentData] = useNodesData([nodeData.parent]);
  const { newColumn, increaseColumn, decreaseColumn } = useColumnOperations({
    parentNodeId: nodeData.parent,
  });

  const offset = parentData.nodes.findIndex((childNodeId) => childNodeId === id);

  return (
    <>
      <Tooltip placement="top" content="Shrink">
        <ButtonIcon
          size="small"
          icon={LineIcon}
          onClick={() => decreaseColumn(id)}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip placement="top" content="Grow">
        <ButtonIcon
          size="small"
          icon={Plus1Icon}
          onClick={() => increaseColumn(id)}
          radius="small"
          color="white"
        />
      </Tooltip>
      <Tooltip placement="top" content="Add Column to Right">
        <ButtonIcon
          size="small"
          icon={CornerRightDownIcon}
          onClick={() => newColumn(offset + 1)}
          radius="small"
          color="white"
        />
      </Tooltip>
    </>
  );
};
